export const STATES = {
  idle: { color: "var(--lab-accent)", label: "Ready when you are", hint: "Take your time" },
  listening: { color: "#E08D46", label: "Listening", hint: "Press again when you're done" },
  reflecting: { color: "#D4A359", label: "Gathering the thread", hint: "Looking through the record" },
  speaking: { color: "#E66A4E", label: "Griot is speaking", hint: "Or take the floor back" },
};

export const CONVO_HINTS = {
  idle: "Just begin — I'm here",
  listening: "I'll know when you're done",
  reflecting: "Holding what you said",
  speaking: "Speak any time to take the floor",
};

export const fmt = (ms) => {
  const t = Math.floor(ms / 1000);
  return `${Math.floor(t / 60)}:${String(t % 60).padStart(2, "0")}`;
};

export const st = (s) => STATES[s] || STATES.idle;
